type EditorTargetSyncListener = () => void;

const editorTargetSyncListeners = new Set<EditorTargetSyncListener>();

export function subscribeEditorTargetSynced(listener: EditorTargetSyncListener): () => void {
  editorTargetSyncListeners.add(listener);
  return () => {
    editorTargetSyncListeners.delete(listener);
  };
}

export function notifyEditorTargetSynced(): void {
  for (const listener of editorTargetSyncListeners) {
    listener();
  }
}
